/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * StreamHub API specification
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * Returns server health status
 * @summary Health check
 */
export const HealthCheckResponse = zod.object({
  status: zod.string(),
});

/**
 * @summary Admin login
 */
export const AdminLoginBody = zod.object({
  password: zod.string(),
});

export const AdminLoginResponse = zod.object({
  token: zod.string(),
  success: zod.boolean(),
});

/**
 * @summary Get all ad settings
 */
export const GetAdSettingsResponse = zod.object({
  data: zod.object({
    slots: zod.array(
      zod.object({
        enabled: zod.boolean(),
        type: zod.enum([
          "banner",
          "video",
          "interstitial",
          "native",
          "script",
          "adsense",
          "custom",
        ]),
        code: zod.string().describe("Raw ad code \/ script"),
        position: zod.enum([
          "top",
          "bottom",
          "sidebar",
          "before-content",
          "after-content",
          "overlay",
          "in-feed",
        ]),
        label: zod.string(),
      }),
    ),
    globalScript: zod
      .string()
      .optional()
      .describe("Global ad script injected in head"),
    adsensePublisherId: zod.string().optional(),
    enabled: zod.boolean(),
  }),
});

/**
 * @summary Update ad settings
 */
export const UpdateAdSettingsBody = zod.object({
  slots: zod.array(
    zod.object({
      enabled: zod.boolean(),
      type: zod.enum([
        "banner",
        "video",
        "interstitial",
        "native",
        "script",
        "adsense",
        "custom",
      ]),
      code: zod.string().describe("Raw ad code \/ script"),
      position: zod.enum([
        "top",
        "bottom",
        "sidebar",
        "before-content",
        "after-content",
        "overlay",
        "in-feed",
      ]),
      label: zod.string(),
    }),
  ),
  globalScript: zod
    .string()
    .optional()
    .describe("Global ad script injected in head"),
  adsensePublisherId: zod.string().optional(),
  enabled: zod.boolean(),
});

export const UpdateAdSettingsResponse = zod.object({
  data: zod.object({
    slots: zod.array(
      zod.object({
        enabled: zod.boolean(),
        type: zod.enum([
          "banner",
          "video",
          "interstitial",
          "native",
          "script",
          "adsense",
          "custom",
        ]),
        code: zod.string().describe("Raw ad code \/ script"),
        position: zod.enum([
          "top",
          "bottom",
          "sidebar",
          "before-content",
          "after-content",
          "overlay",
          "in-feed",
        ]),
        label: zod.string(),
      }),
    ),
    globalScript: zod
      .string()
      .optional()
      .describe("Global ad script injected in head"),
    adsensePublisherId: zod.string().optional(),
    enabled: zod.boolean(),
  }),
});
